import React from 'react';
import { connect } from 'react-redux';
import {
  modifierSalesPageRequest,
  changeDateModifierSales,
  changeOutletModifierSales,
  exportModifierSales,
} from 'actions/reports/sales';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import * as clevertapReportsModifierSales from 'clevertap/reports/modifierSales';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import ActionBar from '../ActionBar';
import styles from './ModifierSales.css';
import ModifierSalesTable from './ModifierSalesTable';
import SimpleModifierSalesTable from './SimpleModifierSalesTable';
import BodyFrame from '../BodyFrame';
import RenderByScreenSize from '../RenderByScreenSize';

class ModifierSales extends React.Component {
  componentDidMount() {
    this.props.modifierSalesPageRequest();
  }

  render() {
    const { location } = this.props;

    return (
      <div id="reports-sales-modifier-sales" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
        />
        <BodyFrame location={location}>
          <RenderByScreenSize
            renderLargeScreen={this.renderLargeScreen}
            renderSmallScreen={this.renderSmallScreen}
          />
        </BodyFrame>
      </div>
    );
  }

  renderLargeScreen = () => {
    const { modifierSalesReport, showLoadingSpinnerReport } = this.props;
    return (
      <ModifierSalesTable
        modifierSalesReport={modifierSalesReport}
        isLoading={showLoadingSpinnerReport}
      />
    );
  };

  renderSmallScreen = () => {
    const { modifierSalesReport, showLoadingSpinnerReport } = this.props;
    return (
      <SimpleModifierSalesTable
        modifierSalesReport={modifierSalesReport}
        isLoading={showLoadingSpinnerReport}
      />
    );
  };

  _onChangeOutlet = (outletIds = []) => {
    const { search, changeOutletModifierSales } = this.props;
    const { startDate, endDate, startHour, endHour, allDay } = search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeOutletModifierSales({
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { search, changeDateModifierSales } = this.props;
    const { outlet } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeDateModifierSales(formattedStart, formattedEnd, outlet);
  };

  _onClickExport = () => {
    const { search, exportModifierSales } = this.props;
    const {
      outlet,
      date: { startDate, endDate, startHour, endHour, allDay },
    } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    const filename = `Report Modifiers - ${dateLabel}`;
    const query = {
      start: formattedStart,
      end: getFormattedEndDate(formattedEnd),
      outletIds: outlet,
      filename,
    };
    clevertapReportsModifierSales.reportsModifierSalesExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    exportModifierSales(query, filename, outlet[0]);
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const {
    modifierSalesReport,
    showLoadingSpinnerReport,
  } = state.reports.modifierSales;
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    modifierSalesReport,
    showLoadingSpinnerReport,
  };
}

const mapDispatchToProps = {
  modifierSalesPageRequest,
  changeOutletModifierSales,
  changeDateModifierSales,
  exportModifierSales,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModifierSales);
